var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16661 3C3.5223 3 2.99997 3.52233 2.99997 4.16667V11.8333C2.99997 12.4777 3.5223 13 4.16661 13H11.8331C12.4774 13 12.9997 12.4777 12.9997 11.8333V9.16667C12.9997 8.89052 13.2236 8.66667 13.4997 8.66667C13.7758 8.66667 13.9997 8.89052 13.9997 9.16667V11.8333C13.9997 13.03 13.0297 14 11.8331 14H4.16661C2.97003 14 2 13.03 2 11.8333V4.16667C2 2.97005 2.97003 2 4.16661 2H6.83321C7.10935 2 7.3332 2.22386 7.3332 2.5C7.3332 2.77614 7.10935 3 6.83321 3H4.16661ZM8.6665 2.5C8.6665 2.22386 8.89035 2 9.16649 2H13.5C13.7761 2 14 2.22386 14 2.5V6.83333C14 7.10948 13.7761 7.33333 13.5 7.33333C13.2239 7.33333 13 7.10948 13 6.83333V3.70716L9.52001 7.1869C9.32475 7.38216 9.00817 7.38214 8.81292 7.18687C8.61768 6.9916 8.61769 6.67501 8.81296 6.47976L12.293 3H9.16649C8.89035 3 8.6665 2.77614 8.6665 2.5Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.dcfca79cb5747c6bcaf56b3b4992b278.svg";
export { ForwardRef as ReactComponent };